import reactComponentLoader from 'scripts/react-component-loader'

import App from './App'

reactComponentLoader(App, '[data-page-recovery]')
